import type { ApiOrgId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import type { OrgDashboardApiIntegrationJob } from './types/OrgDashboardApiIntegrationJob';
import type { OrgDashboardApiIntegrationType } from './types/OrgDashboardApiIntegrationType';

type ApiResponse = {
  jobs: OrgDashboardApiIntegrationJob[];
  hasError: boolean;
};

function mapResponse(response: ApiResponse) {
  return response.jobs;
}

const endpoint = new FetchEndpoint({
  urlFactory: (
    orgId: ApiOrgId,
    type: OrgDashboardApiIntegrationType,
    disabled?: boolean,
  ) => (disabled ? undefined : `/data/orgdashboard/${orgId}/${type}/jobs`),
  mapResponse,
});

// Exports

export const orgDashboardApiIsomorphicFetchIntegrationJobs =
  endpoint.createIsomorphicFetchFn();

export const useOrgDashboardApiFetchIntegrationJobs =
  endpoint.createUseFetchHook();
